export default __webpack_public_path__ + "7c6b44c55d4d9661e3edca40d8a63320.woff2";